export const MessageBoxKey = {
    CheckFiscalPeriod: 1,
    ReloadFiscalPeriod: 2,
    SelectCompany: 3,
    SubmitFinancialStatements: 4
}

export class MessageBoxModel {
    constructor(obj) {
        this.Sid = obj.Sid;
        this.Title = obj.Title;
        this.Pattern = obj.Pattern;
        this.Message = obj.Message;
    }
}